<template>
<b-container>
  <b-row class="mb-2">
    <b-col cols="6">
      <h1></h1>
      <b-form @submit.prevent='buscarPersonal'>
        <b-input-group>
          <b-form-input placeholder="Ingresar DNI" :value='InputDni' @update="filtrarDni" @keypress="soloNumeros" autocomplete="on" maxlength="8" inputmode="numeric" :disabled="disabled"/>
          <b-input-group-append>
            <b-button variant="primary" type="submit" :disabled="disabled">
              <b-icon icon="search"></b-icon>
              Buscar
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form>
    </b-col>
  </b-row>
  <b-row v-if="notEmptyObject(this.Personal)" class="mb-2">
    <b-col cols="12" lg="12">
      <card-datos-personales :personal="this.Personal"></card-datos-personales>
      <br/>
      <div v-if="this.ListaCargoPersonal.length === 0">
        <b-alert variant="danger" show>No se encontraron cargos asociados al personal buscado</b-alert>
      </div>
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
import PersonalSvc from '@/services/personal';
import CardDatosPersonales from './CardDatosPersonales.vue'


const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});
export default {
  name: "FormBuscarPersonal",
  mixins: [errorhandler, swalerts],
  props: {
  },
  watch: {
    'getEstablecimiento': function (newvalue, oldvalue) {
      console.log('refresh table newvalue oldvalue', newvalue, oldvalue);
      console.log('InputDni', this.InputDni);
      if(this.InputDni){
        this.buscarPersonal();
      }
    }
  },
  components: { CardDatosPersonales },
  data() {
    return {
      disabled: false,
    }
  },
  computed: {
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'InputDni']),
    ...mapGetters(['getEstablecimiento']),
  },
  mounted(){
    console.log('created limpiar');
    this.InputDni = null;
    this.limpiar();
  },
  methods:{
    limpiar(){
      this.Personal = null;
      this.ListaCargoPersonal = [];
    },
    filtrarDni(value) {
      this.InputDni = (value || '').replace(/\D/g, '').slice(0, 8);
    },
    soloNumeros(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
    buscarPersonal() {
      console.log('buscarPersonal loading');
      if (!this.InputDni) {
        this.showWarning('Ingrese un DNI para buscar');
        return;
      }
      if (!/^\d{8}$/.test(this.InputDni)) {
        this.showWarning('El DNI debe contener 8 dígitos numéricos');
        return;
      }
      this.disabled = true;
      this.limpiar();
      PersonalSvc.getPersonal({
        Dni: this.InputDni,
        IncluyeCargoPersonal: true,
        unidadeducativa_id: this.getEstablecimiento ? this.getEstablecimiento.UnidadEducativa_Id : 0,
        nivelenseñanza_id: this.getEstablecimiento ? this.getEstablecimiento.NivelEnseñanza_Id : 0
        }).then(response => {
          console.log('fin find personal', response);
          this.Personal = response.data.objeto;
          this.ListaCargoPersonal = response.data.objeto.CargoPersonal || [];

          this.disabled = false;
      })
      .catch(error => {

        this.disabled = false;
        if (error.response && error.response.status === 404) {
          this.showWarning('No se encontró personal con el DNI ingresado. Verifique e intente nuevamente.');
        } else {
          this.errorHandler(error);
        }
        console.log('error buscarPersonal', error);
      });
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/FormBuscarPersonal.vue